/**
 * BecomeContributorCTA — reusable pill that surfaces the community
 * reporting invite across TheNewsPulse.pro pages.
 *
 * Two variants:
 *   - "pill"   → compact rounded pill for headers/nav
 *   - "banner" → full-width strip for page bodies (below hero, above fold)
 */
import { Link } from "react-router-dom";
import { Megaphone, ChevronRight } from "lucide-react";

export default function BecomeContributorCTA({ variant = "pill", className = "" }) {
  if (variant === "banner") {
    return (
      <Link to="/contribute"
            className={`group flex flex-wrap items-center gap-3 rounded-2xl bg-gradient-to-r from-blue-50 via-white to-blue-50 border border-blue-100 px-5 py-4 hover:border-blue-300 transition-colors ${className}`}
            data-testid="become-contributor-banner">
        <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0">
          <Megaphone className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm md:text-lg font-bold text-slate-900">
            See something worth sharing? Become a Community Reporter.
          </div>
          <div className="text-[12px] md:text-sm text-slate-600">
            Registered users can report local news, events, and eyewitness stories on TheNewsPulse.pro.
          </div>
        </div>
        <span className="inline-flex items-center gap-1 bg-blue-600 group-hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors">
          Start <ChevronRight className="w-4 h-4" />
        </span>
      </Link>
    );
  }
  // "pill"
  return (
    <Link to="/contribute"
          className={`inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded-full shadow-sm transition-colors ${className}`}
          data-testid="become-contributor-pill">
      <Megaphone className="w-4 h-4" />
      Become a Community Reporter
    </Link>
  );
}
